import React from "react";
import { Link } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../Navbar/Navbar";
import ContentCard from "./ContentCard";

function Kofedra() {
  const data = [
    {
      name: "Dori turlari texnologiyasi kafedrasi",
      link: 0,
    },
    {
      name: "Farmakognoziya kafedrasi",
      link: 1,
    },
    {
      name: "Farmakologiya va klinik farmatsiya kafedrasi",
      link: 2,
    },
    {
      name: "Farmatsevtika ishini tashkil qilish kofedrasi",
      link: 3,
    },
    {
      name: "Toksikologik kimyo kofedrasi",
      link: 4,
    },
    {
      name: "Analitik kimyo kafedrasi",
      link: 5,
    },
    {
      name: "Organik sintez kafedrasi",
      link: 6,
    },
    {
      name: "Farmatsevtik kimyo kafedrasi",
      link: 7,
    },
    {
      name: "Dori vositalarining sanoat texnologiyasi kafedrasi ",
      link: 8,
    },



    {
      name: "NOORGANIK, FIZIK VA KOLLOID KIMYO KAFEDRASI ",
      link: 9,
    },
    {
      name: "Biotexnologiya kafedrasi ",
      link: 10,
    },
    {
      name: "FARMATSEVTIK ISHLAB CHIQARISHNI TASHKIL QILISH VA SIFAT MENEJMENTI KAFEDRASI  ",
      link: 11,
    },
    {
      name: "FIZIKA, MATEMATIKA VA AXBOROT TEXNOLOGIYALARI KAFEDRASI ",
      link: 12,
    },
    {
      name: "“O`zbek tili va adabiyoti” kafedrasi ",
      link: 13,
    },

    {
      name: "TIBBIY VA BIOLOGIK FANLAR KAFEDRASI  ",
      link: 14,
    },
  ];
  return (
    <div>
      <Navbar />

      <div className="body__rektorat">
        <div className="title">
          <h1>Kafedralar</h1>
        </div>

        {data.map((item) => (
          <Link to={"/typemed/"+ item.link}>
            <div className="row__kof">
              <article>{item.name}</article>
              <img src="./img/arrow.svg" alt="" />
            </div>
          </Link>
        ))}
      </div>
      <Footer />
    </div>
  );
}

export default Kofedra;
